import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./assets/styles/tailwind.css";
import "./assets/styles/index.scss";
import App from "./pages/App";
import { STRINGS } from "./constants";

document.title = STRINGS.app.name;

// Detect if running in iframe and add class to html element
if (window.self !== window.top) {
  document.documentElement.classList.add("in-iframe");
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
